import React from 'react'
import { TextareaAutosize, useTheme } from '@material-ui/core'

import { updateRollDescription } from '../api/rolling'
import { updateEventDescription } from '../api/events'
import CustomModal from './CustomModal'
import LoadingButton from './LoadingButton'

const EditModal = ({ campaignId, description, id, isDarkMode, isEvent, isOpen, loading, setLoading, setIsOpen }) => {
  const textRef = React.useRef(null)
  const theme = useTheme()

  return (
    <CustomModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div css={`height: 100%; display: flex; justify-content: center; align-items: center;`}>
        <div css={`
          position: relative;
          background-color: ${theme.palette.background.paper};
          border-radius: 4px;
          min-width: 300px;
          max-width: 572px;

          margin: 0 8px;

          &:focus {
            outline: none;
          }
        `}>
          <div css={`margin-bottom: 4px; font-weight: bold; font-size: 16px;`}>Edit Description</div>
          <TextareaAutosize
            disabled={loading}
            ref={textRef}
            defaultValue={description}
            rowsMin={3}
            placeholder='Enter a new description for your roll'
            css={`
              width: 100%;
              font-family: 'Roboto';
              background-color: transparent;
              border-radius: 4px;
              border-color: ${isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.3)'};
              padding: 8px;
              margin: 8px 0;

              ${isDarkMode ? 'color: white;' : ''}
            `}
          />
          <div css={`display: flex; justify-content: center;`}>
            <LoadingButton
              onClick={async () => {
                setLoading(true)
                await (isEvent ? updateEventDescription : updateRollDescription)(campaignId, id, textRef?.current?.value)
                setIsOpen(false)
                setLoading(false)
              }} />
          </div>
        </div>
      </div>
    </CustomModal>
  )
}

export default EditModal
